<template>
  <div :class="$style.root">
    <button :class="$style.root__close">
      <IconClose @click="$emit('close')" />
    </button>
    <header :class="$style.root__header">
      <p :class="$style.header__text">検索条件を削除</p>
    </header>
    <div :class="$style.root__content">
      <p :class="$style.content__comment">
        「{{ selectedFilteringRuleLabel }}」を削除しますか？
      </p>
      <FlatButton
        :class="$style.root__button"
        variant="caution"
        size="medium"
        @click="submit"
      >
        検索条件を削除
      </FlatButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconClose from '@/components/icons/IconClose.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

withDefaults(
  defineProps<{
    selectedFilteringRuleLabel: string
  }>(),
  {
    selectedFilteringRuleLabel: '',
  }
)

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'submit'): void
}>()

const submit = () => {
  emit('submit')
  emit('close')
}
</script>

<style lang="scss" module>
.root {
  width: 600px;
  height: 100%;
  padding: 22px;

  &__close {
    display: block;
    width: 12px;
    margin-left: auto;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
  }

  &__button {
    margin-top: 24px;
  }
}

.header {
  &__text {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
}

.content {
  &__comment {
    font-size: 16px;
  }
}
</style>
